<template>
  <div>
    <div v-if="Array.isArray(collection)">
      <explorer v-for="(obj, index) in collection" :key="index"
                :collection="obj"
                :title-by="titleBy"
                :level="level ? level + 1 : 1"
                @clicked="childClicked(obj.child)"
      />
    </div>

    <div v-else>
      <div :class="`border table-bordered py-2 mt-3 pl-2 mt-2 ${level > 1 ? 'border-right-0' : 'border-secondary '}`"
           :style="`${level > 1 ? '' : 'border-radius: .25rem;'} `">
        <b-container class="mw-100 m-0 p-0">
          <b-row v-if="collection[titleBy]" align-v="center">
            <b-col cols="auto">
              <font-awesome-icon
                v-if="collections && collections.length !== 0"
                :icon="showChild ? 'folder-open' : 'folder'"
                class="c-blue hover-enabled my-fixed-icon"
                :size="isMobile ? 'md' : 'lg'"
                @click="showChild = !showChild" />

              <font-awesome-icon v-else
                                 icon="file-alt"
                                 :size="isMobile ? 'md' : 'lg'"
                                 class="c-green my-fixed-icon"/>
            </b-col>

            <b-col cols="auto">
              <h5 class="mb-0 pb-0">
                {{ collection[titleBy] }}
              </h5>
            </b-col>

            <b-col cols="auto" class="ml-auto">
              <b-form-checkbox v-model="collection.config.r"
                               class="d-inline-flex ml-3 mr-3"
                               v-if="collection.config && (collection.config.r === false || collection.config.r)"
                               :indeterminate="indeterminate.r"
                               v-b-popover.hover.top="`${$tc('message.read', 1)}`"
                               @change="handleClick($event, 'r')">
                <font-awesome-icon
                  icon="search" :size="isMobile ? 'md' : 'lg'"
                  :class="`my-fixed-icon ${collection.config.r ? 'c-green' : 'c-ls-gray'}`"/>
              </b-form-checkbox>

              <!-- config[crud], create - read - update - delete -->
              <b-form-checkbox v-model="collection.config.c"
                               class="d-inline-flex ml-3 mr-3"
                               :disabled="!collection.config.r"
                               v-if="collection.config && (collection.config.c === false || collection.config.c)"
                               v-b-popover.hover.top="`${$tc('message.create', 1)}`"
                               :indeterminate="indeterminate.c"
                               @change="handleClick($event, 'c')">
                <font-awesome-icon
                  icon="plus" :size="isMobile ? 'md' : 'lg'"
                  :class="`my-fixed-icon ${collection.config.c ? 'c-green' : 'c-ls-gray'}`"/>
              </b-form-checkbox>

              <!-- config[crud], create - read - update - delete -->
              <b-form-checkbox v-model="collection.config.u"
                               class="d-inline-flex ml-3 mr-3"
                               :disabled="!collection.config.r || !collection.config.c"
                               v-if="collection.config && (collection.config.u === false || collection.config.u)"
                               v-b-popover.hover.top="`${$tc('message.update', 1)}`"
                               :indeterminate="indeterminate.u"
                               @change="handleClick($event, 'u')">
                <font-awesome-icon
                  icon="pencil-alt" :size="isMobile ? 'md' : 'lg'"
                  :class="`my-fixed-icon ${collection.config.u ? 'c-green' : 'c-ls-gray'}`"/>
              </b-form-checkbox>

              <!-- config[crud], create - read - update - delete -->
              <b-form-checkbox v-model="collection.config.d"
                               class="d-inline-flex ml-3 mr-3"
                               v-if="collection.config && (collection.config.d === false || collection.config.d)"
                               :disabled="!collection.config.r"
                               v-b-popover.hover.top="`${$tc('message.delete', 1)}`"
                               :indeterminate="indeterminate.d"
                               @change="handleClick($event, 'd')">
                <font-awesome-icon
                  icon="trash-alt" :size="isMobile ? 'md' : 'lg'"
                  :class="`my-fixed-icon ${collection.config.d ? 'c-green' : 'c-ls-gray'}`"/>
              </b-form-checkbox>
            </b-col>
          </b-row>

          <transition :name="showChild ? 'fade-down' : 'fade-up'" mode="out-in">
            <b-row v-show="showChild || Array.isArray(collection)" class="mt-2 mb-3">
              <b-col cols="12" v-for="(obj, index) in collections" :key="index">
                <explorer
                  ref="explorer"
                  class="ml-0 ml-sm-0 ml-md-2 ml-lg-3 ml-xl-3"
                  :collection="obj"
                  :title-by="titleBy"
                  :level="level ? level + 1 : 1"
                  @clicked="childClicked(collections)"
                />
              </b-col>
            </b-row>
          </transition>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  props: [
    'collection',
    'titleBy',
    'level'
  ],
  name: 'explorer',
  mounted () {
    this.collections = this.getCollection(this.collection)
    this.$root.$on('resize', () => {
      this.updateSize(Vue.myGetWindowSize())
    })
    this.updateSize(Vue.myGetWindowSize())
  },
  data () {
    return {
      collections: [],
      showChild: false,
      isMobile: false,
      size: null,
      indeterminate: {
        c: false,
        r: false,
        u: false,
        d: false
      }
    }
  },
  methods: {
    getCollection (collection) {
      return collection && collection.child && collection.child.length !== 0 ? collection.child : []
    },
    updateSize (size) {
      this.size = size
      this.isMobile = size !== 'lg' && size !== 'xl'
    },
    handleClick (val, attr) {
      this.collection.config[attr] = val
      if (!val) {
        const fields = attr === 'r' ? ['c', 'u', 'd'] : (attr === 'c' ? ['u'] : [])

        fields.forEach(field => {
          if (this.collection && this.collection.config &&
            (this.collection.config[field] === false || this.collection.config[field])) this.collection.config[field] = false
        })
      }

      const children = this.$refs.explorer
      if (children && children.length !== 0) {
        children.forEach(child => {
          child.changeAllAttrs(attr, val)
        })
      }

      this.$emit('clicked', this.collection)
    },
    childClicked (collection) {
      const fields = ['c', 'r', 'u', 'd']
      const counters = {}
      const childCounters = {}

      fields.forEach(field => {
        counters[field] = 0
        childCounters[field] = 0
        if (collection) {
          collection.forEach(child => {
            if (child.config && child.config[field]) counters[field]++
            if (child.config && (child.config[field] || child.config[field] === false)) childCounters[field]++
          })
        }
        this.indeterminate[field] = counters[field] > 0 && childCounters[field] > 0 && counters[field] !== childCounters[field]

        if (this.collection && this.collection.config &&
          (this.collection.config[field] || this.collection.config[field] === false)) this.collection.config[field] = counters[field] > 0
      })
      this.$emit('clicked', collection)
    },
    changeAllAttrs (attr, val) {
      if (this.collection && this.collection.config &&
        (this.collection.config[attr] || this.collection.config[attr] === false)) {
        const children = this.$refs.explorer
        // config[crud], create - read - update - delete
        if ((attr === 'u' && this.collection.config.c)) this.collection.config[attr] = val
        else if ((attr === 'c' && this.collection.config.r)) this.collection.config[attr] = val
        else if (attr === 'r' || attr === 'd') this.collection.config[attr] = val

        // config[crud], create - read - update - delete
        if (attr === 'r' && !val) {
          if (this.collection.config.c) this.collection.config.c = false
          if (this.collection.config.u) this.collection.config.u = false
          if (this.collection.config.d) this.collection.config.d = false
        }
        if (attr === 'c' && !val) {
          if (this.collection.config.u) this.collection.config.u = false
        }

        if (children && children.length !== 0) {
          children.forEach(child => {
            child.changeAllAttrs(attr, val)
          })
        }
      }
    }
  }
}
</script>

<style scoped>
  .fade-down-enter-active {
    transition: all .5s ease;
  }
  .fade-down-leave-active {
    transition: all .5s
  }
  .fade-down-enter {
    transform: translateY(-30px);
    opacity: 0;
  }
  .fade-down-leave-to {
    transform: translateY(30px);
    opacity: 0;
  }

  .fade-up-enter-active {
    transition: all .5s ease;
  }
  .fade-up-leave-active {
    transition: all .5s revert;
  }
  .fade-up-enter {
    transform: translateY(30px);
    opacity: 0;
  }
  .fade-up-leave-to {
    transform: translateY(-30px);
    opacity: 0;
  }

  .my-fixed-icon {
    width: 25px !important;
  }
</style>
